const Wrapper = require('../Wrapper');
const CityInputWrapper = require('../CityInputWrapper');
const DatepickerWrapper = require('../DatepickerWrapper');
const GoodWrapper = require('../GoodWrapper');

class TravelDataModel {
    constructor() {
        this.fromCity = null;
        this.toCity = null;
        this.departureDate = 0;
        this.arrivalDate = 0;
        this.transportType = -1;
        this.goods = [];
        this.transits = [];
    }
}

class TravelDataWrapper extends Wrapper {
    constructor(model = new TravelDataModel()) {
        super();
        this.model = model;

        this.initWrappers();

        if(this.model.goods.length == 0)
        {
            this.addGood();
        }

        this.maxTransits = 2;
        this.minGoods = 1;

        this.syncUIWithModel();

        this.initEvents();
    }

    updateModelTransits() {
        let transits = [];
        this.transits.forEach(tw => {
            transits.push(tw.model);
        });

        this.updateModel( { transits });
    }

    updateModelGoods() {
        let goods = [];
        this.goods.forEach(gw => {
            goods.push(gw.model);
        });

        this.updateModel( { goods });
    }

    initWrappers() {
        this.transits = [];

        let goods = [];

        this.model.goods.forEach((gm, i) => {
            let id = 'good-' + i + '-' + ~~(Math.random() * 10);
            let gw = new GoodWrapper(id, gm);

            gw.addListener(() => {
                this.updateModelGoods();
            });

            goods.push(gw);
        });

        this.goods = goods;

        this.fromCity = new CityInputWrapper('fromCity');
        this.toCity = new CityInputWrapper('toCity');

        this.arrivalDate = new DatepickerWrapper('arrivalDate');
        this.arrivalDate.minDate = new Date();
    }

    addTransit() {
        if(this.transits.length >= this.maxTransits) return;

        let id = 'transit-' + this.transits.length + '-' + ~~(Math.random() * 10);
        let tw = new TransitWrapper(id);
        tw.autoValidation = false;

        tw.addListener(() => {
            this.updateModelTransits();
        });

        this.transits.push(tw);

        let transitModels = [];
        this.transits.forEach(transit => transitModels.push(transit.model));

        this.updateTransitsUI();
        this.updateModel({ transits: transitModels });
    }

    addGood() {
        let id = 'good-' + this.goods.length + '-' + ~~(Math.random() * 10);
        let gw = new GoodWrapper(id);

        gw.addListener(() => {
            this.updateModelGoods();
        });

        this.goods.push(gw);

        let goodsModels = [];
        this.goods.forEach(good => goodsModels.push(good.model));

        this.updateGoodsUI();
        this.updateModel({ goods: goodsModels });
    }

    get transportType() {
        return Number(window.$('#mainTransportType').val());
    }

    set transportType(value) {
        window.$('#mainTransportType').val(value).selectric('refresh');
    }

    updateTransitsUI() {
        if (this.transits.length == 0) {
            $('#transitsTitle').hide();
        } else {
            $('#transitsTitle').show();
        }

        document.getElementById('transits').innerHTML = '';

        this.transits.forEach((tr, index) => {
            document.getElementById('transits').innerHTML += tr.template(index + 1);
        });

        window.$(`#transits select`).selectric({
            disableOnMobile: false,
            nativeOnMobile: false,
            optionsItemBuilder: function (itemData, element, index) {
                return itemData.className.length ? '<svg class="select-icon"><use xlink:href="#' + itemData.className.substr(5) + '"></use></svg>' + itemData.text : itemData.text;
            }
        });

        this.transits.forEach(tr => {
            tr.initWrappers();
            tr.syncUIWithModel();
        });

        // update events
        $("button[data-delete-transit]").on('click', e => {
            let id = e.delegateTarget.getAttribute('data-delete-transit');
            this.removeTransit(id);
        });
    }

    updateGoodsUI() {
        let str = '';
        this.goods.forEach((good, index) => {
            str += good.template(index + 1);
        });

        document.getElementById('goods').innerHTML = str;

        window.$(`#goods select`).selectric({
            disableOnMobile: false,
            nativeOnMobile: false,
            optionsItemBuilder: function (itemData, element, index) {
                return itemData.className.length ? '<svg class="select-icon"><use xlink:href="#' + itemData.className.substr(5) + '"></use></svg>' + itemData.text : itemData.text;
            }
        });

        this.goods.forEach(good => {
            good.initWrappers();
            good.syncUIWithModel();
        });

        // update events
        $("button[data-delete-good]").on('click', e => {
            let id = e.delegateTarget.getAttribute('data-delete-good');
            this.removeGood(id);
        });
    }

    syncUIWithModel() {
        this.updateTransitsUI();
        this.updateGoodsUI();

        if(this.model.fromCity)
        {
            this.fromCity.updateModel(this.model.fromCity);
            this.fromCity.updateUI();
        }

        if(this.model.toCity)
        {
            this.toCity.updateModel(this.model.toCity);
            this.toCity.updateUI();
        }

        if(this.model.arrivalDate && this.model.arrivalDate !== 0)
        {
            this.arrivalDate.updateModel( { value: this.model.arrivalDate });
            this.arrivalDate.updateUI();
        }

        if(this.model.transportType && this.model.transportType !== 0) this.transportType = this.model.transportType;
    }

    removeTransit(id) {
        this.transits = this.transits.filter(tr => tr.id != id);

        let transitModels = [];
        this.transits.forEach(transit => transitModels.push(transit.model));
        this.updateModel({ transits: transitModels });

        this.updateTransitsUI();
    }

    removeGood(id) {
        if(this.goods.length <= this.minGoods) return;

        this.goods = this.goods.filter(good => good.id != id);

        let goodsModels = [];
        this.goods.forEach(good => goodsModels.push(good.model));
        this.updateModel({ goods: goodsModels });

        this.updateGoodsUI();
    }

    getWrappersList() {
        let wrappers = [this.fromCity, this.toCity, this.arrivalDate];

        this.transits.forEach(tr => wrappers.push(tr));
        this.goods.forEach(gd => wrappers.push(gd));

        return wrappers;
    }

    validate() {
        this.getWrappersList().forEach(wr => wr.validate());

        let $mainTransportType = $("#mainTransportType");
        if($mainTransportType.val() !== "0") $mainTransportType.parent().parent().removeClass('invalid');
        else $mainTransportType.parent().parent().addClass('invalid');
    }

    isValid() {
        // check all child wrappers validity
        let criteria1 = this.getWrappersList().filter(wr => !wr.isValid()).length === 0;

        // check 'mainTransportType' select validity [required]
        let criteria2 = $("#mainTransportType").val() !== "0";

        return criteria1 && criteria2;
    }

    initEvents() {

        document.getElementById('addGood').addEventListener('click', () => {
            this.addGood();
        });

        this.fromCity.addListener(() => {
            this.updateModel({fromCity: this.fromCity.model});
        });

        this.toCity.addListener(() => {
            this.updateModel({toCity: this.toCity.model});
        });

        this.arrivalDate.addListener(() => {
            this.updateModel({ arrivalDate: this.arrivalDate.model.value });
        });

        window.$('#mainTransportType').on('change', () => {
            this.updateModel({ transportType: this.transportType })
        });

        let travelDataChangeCallback = () => {
            // update goods view
            setTimeout(function() {
                this.goods.forEach(good => good.removeButtonVisibility(this.goods.length !== 1));
                this.goods.forEach(good => good.cityInputsVisibility(this.transits.length !== 0));
            }.bind(this), 0);
        };

        this.addListener(travelDataChangeCallback);

        travelDataChangeCallback();
    }
}

module.exports = TravelDataWrapper;